import { z } from 'zod';

export const MEMBER_EMAIL_WINDOW_DAYS = 45;
export const MEMBER_EMAIL_LIMIT = 20;

export const MemberMarketingEmailSchema = z.object({
  sentAt: z.string(),
  type: z.enum(['campaign', 'flow']),
  name: z.string().nullable(),
  subject: z.string().nullable(),
  opened: z.boolean(),
  clicked: z.boolean(),
});
export type MemberMarketingEmail = z.infer<typeof MemberMarketingEmailSchema>;

export const KlaviyoMemberEmailsResultSchema = z.union([
  z.object({
    identified: z.literal(true),
    klaviyoProfile: z.literal(true),
    emails: z.array(MemberMarketingEmailSchema).max(MEMBER_EMAIL_LIMIT),
  }),
  z.object({
    identified: z.literal(true),
    klaviyoProfile: z.literal(false),
    emails: z.array(MemberMarketingEmailSchema).length(0),
  }),
  z.object({ identified: z.literal(false), reason: z.string() }),
  z.object({ available: z.literal(false) }),
]);
export type KlaviyoMemberEmailsResult = z.infer<typeof KlaviyoMemberEmailsResultSchema>;
